import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IUniversalDateModalData } from './models/universalDateModalData';
import { IPresetInput } from '../../components/ph-datepicker/ph-datepicker/preset';

@Component({
    selector: 'app-complex-deadline-modal',
    templateUrl: './complex-deadline-modal.component.html',
    styleUrls: ['./complex-deadline-modal.component.scss'],
    standalone: false
})
export class ComplexDeadlineModalComponent implements OnInit {
	private _updateForAll: boolean = false;
	get updateForAll(): boolean {
		return this._updateForAll;
	}
	set updateForAll(value: boolean) {
		this._updateForAll = value;
		this.updateDateConstraints();
	}

	private _date: Date | null = null;
	get date(): Date | null {
		return this._date;
	}
	set date(value: Date | null) {
		this._date = value;
		this.updateToggleState();
	}

	mode: string;
	title: string = 'DEADLINE.MODAL.TITLE';
	dateInputLabel: string = 'DEADLINE.MODAL.DOING_TO';
	datepickerPlaceholder: string = '';
	toggleLabel: string = 'DEADLINE.MODAL.UPDATE_FOR_ALL';
	presets: Array<IPresetInput> = [];
	info: string = '';

	minDate: string = new Date().toString();
	maxDate: string | null = null;
	private initialMaxDate: string | null = null;
	private maxDateAll: string | null = null;
	private maxDateUns: string | null = null;
	private minDateAll: string;
	private minDateUns: string;
	toggleDisabled: boolean = false;

	constructor(
		private dialogRef: MatDialogRef<ComplexDeadlineModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: IUniversalDateModalData
	) {}

	ngOnInit(): void {
		if (this.data.title) this.title = this.data.title;
		if (this.data.dateInputLabel) this.dateInputLabel = this.data.dateInputLabel;
		if (this.data.datepickerPlaceholder) this.datepickerPlaceholder = this.data.datepickerPlaceholder;
		if (this.data.toggleLabel) this.toggleLabel = this.data.toggleLabel;
		if (this.data.state) this.date = this.data.state;
		if (this.data.presets) this.presets = this.data.presets;
		if (this.data.info) this.info = this.data.info;
		if (this.data.toggleDisabled) this.toggleDisabled = this.data.toggleDisabled;
		if (this.data.mode) this.mode = this.data.mode;

		this.initialMaxDate = this.data.maxDate ?? null;

		this.maxDateAll = this.data.maxDateAll ?? null;
		this.maxDateUns = this.data.maxDateUns ?? null;
		this.minDateAll = this.data.minDateAll ?? this.data.minDate ?? new Date().toString();
		this.minDateUns = this.data.minDateUns ?? this.data.minDate ?? new Date().toString();

		this.updateDateConstraints();
		this.updateToggleState();
	}

	apply(): void {
		if (!this.date) return;
		this.dialogRef.close({
			date: this.date,
			updateForAll: this._updateForAll
		});
	}

	cancel(): void {
		this.dialogRef.close({
			date: null
		});
	}

	setDate(value: Date | null): void {
		this.date = value;
	}

	private updateDateConstraints(): void {
		if (this.data.mode == 'scheduled') {
			if (this._updateForAll) {
				const tomorrow = new Date();
				tomorrow.setDate(tomorrow.getDate() + 1);
				this.minDate = tomorrow.toString();
				this.maxDate = this.maxDateAll;
			} else {
				this.minDate = this.minDateAll;
				this.maxDate = this.maxDateUns;
			}
		}
		else if (this.data.mode == 'deadline') {
			if (this._updateForAll) {
				this.minDate = this.minDateAll;
				this.maxDate = null;
			} else {
				this.minDate = this.minDateUns;
				this.maxDate = this.initialMaxDate;
			}
		}
	}

	private updateToggleState(): void {
		if (!this.date) {
			this.toggleDisabled = false;
			return;
		}

		const selectedDate = new Date(this.date);

		if (this.data.mode == 'scheduled') {
			if (this.maxDateAll) {
				const maxDeadlineAll = new Date(this.maxDateAll);
				if (selectedDate > maxDeadlineAll) {
					this._updateForAll = false;
					this.toggleDisabled = true;
				} else {
					this.toggleDisabled = false;
				}
			} else if (this.maxDateUns) {
				const maxDeadlineUns = new Date(this.maxDateUns);
				if (selectedDate > maxDeadlineUns) {
					this._updateForAll = false;
					this.toggleDisabled = true;
				} else {
					this.toggleDisabled = false;
				}
			} else {
				this.toggleDisabled = false;
			}
		} else if (this.data.mode == 'deadline') {
			if (this.minDateAll) {
				const minScheduledAll = new Date(this.minDateAll);
				if (selectedDate < minScheduledAll) {
					this._updateForAll = false;
					this.toggleDisabled = true;
				} else {
					this.toggleDisabled = false;
				}
			} else if (this.minDateUns) {
				const minScheduledUns = new Date(this.minDateUns);
				if (selectedDate < minScheduledUns) {
					this._updateForAll = false;
					this.toggleDisabled = true;
				} else {
					this.toggleDisabled = false;
				}
			} else {
				this.toggleDisabled = false;
			}
		}
	}
}